import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./landingpage2";
import Introduction from "./Introduction";
import Activity from "./Activity";
import Initiative from "./Initiatives";
import Sector from "./Sector";
import {LandingPage1} from "./landingpage2";
import FullWidthTabs from "./TabPanel";
import OrganizationTabs from "./OrganizationTabs";
import JoinUs from "./JoinUs";
import Agri from "./Agri";
import Energy from "./Energy";
import TourismComponent from "./TourismComponent";
import EducationComponent from "./EducationComponent";
import EnvironmentComponent from "./EnvironmentComponent";
import BoardOfDirectors from "./defaultBoardMembers";
import Events from "./Events";
import Blogs from "./Blogs";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage1/>} />
      <Route path="/introduction" element={<OrganizationTabs/>} />
      <Route path="/tactical-activities" element={<Activity/>} />
      <Route path="/initiatives" element={<Initiative />} />
      <Route path="/sector" element={<Sector />} />
      <Route path="/agri-tech" element={<Agri/>}/>
      <Route path="/join-us" element={<JoinUs/>}/>
      <Route path="/energy" element={<Energy/>}/>
      <Route path="/tourism" element={<TourismComponent/>}/>
      <Route path="/education" element={<EducationComponent/>}/>
      <Route path="/environment" element={<EnvironmentComponent/>}/>
      <Route path="/directors" element={<BoardOfDirectors/>}/>
      <Route path="/events" element={<Events/>}/>
      <Route path="/blogs" element={<Blogs/>}/>
      {/* Add more routes as needed */}
    </Routes>
  );
};

export default AppRoutes;
